import { useState } from "react";

type InforAccordionProps = {
  data: { title: string; info: string };
  isDefaultOpen?: boolean;
};

export default function InfoAccordion({
  data,
  isDefaultOpen,
}: InforAccordionProps) {
  const [open, setOpen] = useState(isDefaultOpen ? true : false);

  return (
    <article
      onClick={() => setOpen(!open)}
      className="py-3 md:py-5 border-b border-[#62636C4A] cursor-pointer select-none"
    >
      {/* Title */}
      <h3 className="text-[#1C1C1C] text-sm md:text-xl lg:text-3xl font-semibold">
        {data.title}
      </h3>

      {/* Animated content */}
      <div
        className={`grid transition-all duration-300 ease-in-out ${
          open
            ? "grid-rows-[1fr] opacity-100 mt-1"
            : "grid-rows-[0fr] opacity-0"
        }`}
      >
        <p className="overflow-hidden text-[#62636C] text-[14px] md:text-base">
          {data.info}
        </p>
      </div>
    </article>
  );
}
